import { Vector3, Color } from "three";
import { config } from "./config";
import AtlasPlanes from "./AtlasPlanes.js";
import { random, TO_RAD } from "~/lib/utils.js";

export default class MaskLines extends AtlasPlanes {
    preInit() {
        this.texturePath = "/about/maskTextures.png";
        this.planeCount = 30;
        this.shapeCount = 2;
        this.instancing = config.instancing;
    }

    initPlane(plane) {
        const size = random(0.5, 1.5);

        plane.initScale = new Vector3(0.2, 2, 1);
        plane.initScale.x *= random(0.8, 1.1) * size;
        plane.initScale.y *= random(1, 1.1) * size;

        plane.scale.copy(plane.initScale);
        plane.rotation.z = random(360) * TO_RAD;

        plane.color = new Color(0x000000);
    }

    updatePlane(plane, progress) {
        plane.scale.x = plane.initScale.x * progress * 6;
        plane.scale.y = plane.initScale.y * progress * 6;
    }
}
